export default __webpack_public_path__ + "static/media/photoshop.87991411.svg";